import serializeError from 'serialize-error'
import { checkId } from './utils'
import merge from 'lodash/merge'
import isObject from 'lodash/isObject'
export default function makeServiceMutations () {
  function addItems (state, items) {
    const { idField } = state
    let newKeyedById = { ...state.keyedById }

    for (let item of items) {
      let id = item[idField]
      const isIdOk = checkId(id, item)

      if (isIdOk) {
        // Only add the id if it's not already in the `ids` list.
        if (!state.ids.includes(id)) {
          state.ids.push(id)
        }
        newKeyedById[id] = item
      }
    }
    state.keyedById = newKeyedById
  }

  function updateItems (state, items) {
    const { idField, replaceItems, addOnUpsert } = state
    let newKeyedById = { ...state.keyedById }

    for (let item of items) {
      let id = item[idField]
      const isIdOk = checkId(id, item)

      // Simply rewrite the record if the it's already in the `ids` list.
      if (isIdOk && state.ids.includes(id)) {
        if (replaceItems) {
          newKeyedById[id] = item
        } else {
          merge(newKeyedById[id], item)
        }
        continue
      }

      // if addOnUpsert then add the record into the state, else discard it.
      if (addOnUpsert) {
        state.ids.push(id)
        newKeyedById[id] = item
      }
    }

    state.keyedById = newKeyedById
  }

  const mutations = {
    setData (state, payload) {
      state.data = payload
    },
    setFindPending (state) {
      state.isFindPending = true
    },
    unsetFindPending (state) {
      state.isFindPending = false
    },
    setGetPending (state) {
      state.isGetPending = true
    },
    unsetGetPending (state) {
      state.isGetPending = false
    },
    setCreatePending (state) {
      state.isCreatePending = true
    },
    unsetCreatePending (state) {
      state.isCreatePending = false
    },
    setUpdatePending (state) {
      state.isUpdatePending = true
    },
    unsetUpdatePending (state) {
      state.isUpdatePending = false
    },
    setPatchPending (state) {
      state.isPatchPending = true
    },
    unsetPatchPending (state) {
      state.isPatchPending = false
    },
    setRemovePending (state) {
      state.isRemovePending = true
    },
    unsetRemovePending (state) {
      state.isRemovePending = false
    },

    setFindError (state, payload) {
      state.errorOnFind = Object.assign({}, serializeError(payload))
    },
    clearFindError (state) {
      state.errorOnFind = null
    },
    setGetError (state, payload) {
      state.errorOnGet = Object.assign({}, serializeError(payload))
    },
    clearGetError (state) {
      state.errorOnGet = null
    },
    setCreateError (state, payload) {
      state.errorOnCreate = Object.assign({}, serializeError(payload))
    },
    clearCreateError (state) {
      state.errorOnCreate = null
    },
    setUpdateError (state, payload) {
      state.errorOnUpdate = Object.assign({}, serializeError(payload))
    },
    clearUpdateError (state) {
      state.errorOnUpdate = null
    },
    setPatchError (state, payload) {
      state.errorOnPatch = Object.assign({}, serializeError(payload))
    },
    clearPatchError (state) {
      state.errorOnPatch = null
    },
    setRemoveError (state, payload) {
      state.errorOnRemove = Object.assign({}, serializeError(payload))
    },
    clearRemoveError (state) {
      state.errorOnRemove = null
    },

    addToExpandedItems (state, payload) {
      state.expandedItems.push(payload)
    },
    removeFromExpandedItems (state, payload) {
      state.expandedItems = state.expandedItems.filter(item => item !== payload)
    },
    clearExpandedItems (state) {
      state.expandedItems = []
    },

    addItem (state, item) {
      addItems(state, [item])
    },
    addItems (state, items) {
      addItems(state, items)
    },
    updateItem (state, item) {
      updateItems(state, [item])
    },
    updateItems (state, items) {
      if (!Array.isArray(items)) {
        throw new Error('You must provide an array to the `updateItems` mutation.')
      }
      updateItems(state, items)
    },
    removeItem (state, item) {
      const { idField } = state
      const idToBeRemoved = isObject(item) ? item[idField] : item
      const keyedById = {}
      const { currentId } = state

      const isIdOk = checkId(idToBeRemoved, item)
      if (isIdOk) {
        state.ids = state.ids.filter(id => {
          if (id === idToBeRemoved) {
            return false
          } else {
            keyedById[id] = state.keyedById[id]
            return true
          }
        })
        state.keyedById = keyedById
        if (currentId === idToBeRemoved) {
          state.currentId = null
          state.copy = null
        }
      }
    },
    clearAll (state) {
      state.ids = []
      state.currentId = null
      state.copy = null
      state.keyedById = {}
    },
    clearList (state) {
      let currentId = state.currentId
      let current = state.keyedById[currentId]

      if (currentId && current) {
        state.keyedById = {
          [currentId]: current
        }
        state.ids = [currentId]
      } else {
        state.keyedById = {}
        state.ids = []
      }
    },
    setCurrent (state, itemOrId) {
      const { idField } = state
      let id
      if (isObject(itemOrId)) {
        id = itemOrId[idField]
      } else {
        id = itemOrId
      }
      state.currentId = id
    },
    clearCurrent (state) {
      state.currentId = null
      state.copy = null
    },
    setUploadPending (state) {
      state.isUploadPending = true
    },
    unsetUploadPending (state) {
      state.isUploadPending = false
    },
    updatePaginationForQuery (state, { pagination }) {
      state.pagination = pagination
    },
    setCanceller (state, payload) {
      state.canceller = payload
    },
    unsetCanceller (state) {
      state.canceller = null
    }
  }
  return mutations
}
